<section *ngIf="isDebugMode$ | async">
    <ion-card-header>
        <ion-card-subtitle>Debug information</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content [innerHTML]="data | prettyJson"></ion-card-content>
</section>